<script setup lang="ts">
import { flattenEntity } from 'strapi-flatten-graphql'
import type { FeaturedHero } from '~/models/Strapi'

interface Props {
  datas: FeaturedHero
}

const props = defineProps<Props>()
const flattenData = { ...props.datas, image: flattenEntity(props.datas?.bg_image?.data)?.url } as FeaturedHero
</script>

<template>
  <BaseAtomsSkeletonBounded y-padding="lg" class="text-gray-700 text-center !p-0">
    <div class="!bg-cover" :style="`background: url(${flattenData?.image})`">
      <div class="w-full md:w-[440px] mx-auto space-y-6 py-10 lg:py-16 px-4 sm:px-6 lg:px-8">
        <p class="text-indigo-700 font-medium">
          {{ flattenData?.subtitle }}
        </p>
        <p class="font-bold text-3xl mb-1 leading-10">
          {{ flattenData?.title }}
        </p>
        <div class="mb-20 text-sm">
          {{ flattenData?.description }}
        </div>
        <BaseAtomsButton size="sm" class="w-full mt-20 font-medium" :to="flattenData?.button_url">
          {{ flattenData?.button_label }}
        </BaseAtomsButton>
      </div>
    </div>
  </BaseAtomsSkeletonBounded>
</template>
